import { Component } from "@angular/core";
import { Platform } from "ionic-angular";
import { StatusBar } from "@ionic-native/status-bar";
import { SplashScreen } from "@ionic-native/splash-screen";

import { TabsPage } from "../pages/tabs/tabs";
import { Storage } from "@ionic/storage/dist/storage";
import { Events } from "ionic-angular/util/events";
//import { AlertController } from "ionic-angular/components/alert/alert-controller";
//import { ModalController } from "ionic-angular/components/modal/modal-controller";
import { WhiskyDB } from "../data/db";
//import { File } from "@ionic-native/file";
//import { User } from "../providers/providers";
import { Network } from "@ionic-native/network";
//import { ToastController } from "ionic-angular/components/toast/toast-controller";
//import { AngularFireDatabase } from "angularfire2/database";
//import { WhiskyDB_fb } from "../data/fbDb";

@Component({
  templateUrl: "app.html"
})
export class WhiskyWall {
  rootPage: any = TabsPage;

  disconnectSubscription: any;
  connectSubscription: any;


  constructor(
    private platform: Platform,
    statusBar: StatusBar,
    splashScreen: SplashScreen,
    private storage: Storage,
    private events: Events,
    private net: Network,
    //private toaster: ToastController,
    //private alertCtrl: AlertController,
    //private modalCtrl: ModalController,
    //private file: File,
    //private user: User,
    //afDatabase: AngularFireDatabase
  ) {
    console.log("Before platform.ready()")
    this.platform.ready().then(() => {
      //WhiskyDB_fb.init(user, afDatabase, toaster);

      // Okay, so the platform is ready and our plugins are available.
      // Here you can do any higher level native things you might need.
      WhiskyDB.networkUp = navigator.onLine;
      
      WhiskyDB.db.setStorage(this.storage);
      WhiskyDB.db.setEvent(this.events);

      /*WhiskyDB.db.setPlatform(this.platform);
      WhiskyDB.db.setFile(this.file);
      WhiskyDB.db.setUser(this.user); */
  
      WhiskyDB.db.loadAll();
      
      statusBar.styleDefault();
      splashScreen.hide();
      
    
      this.disconnectSubscription = this.net.onDisconnect().subscribe(() => {
        console.log('network was disconnected :-(');
        console.log("downlink: " + this.net.downlinkMax);
        console.log("network: " + this.net.type);
        WhiskyDB.networkUp = false;

        });
      this.connectSubscription = this.net.onConnect().subscribe(() => {
        console.log('network was connected :-)');
        console.log("downlink: " + this.net.downlinkMax);
        console.log("network: " + this.net.type);
        WhiskyDB.networkUp = true;
        
        });
      
    });
  }
}




// WEBPACK FOOTER //
// ./src/app/app.component.ts